<template>

	<div class="bottom-sheet-steps">
		<div
			class="step"
			:style="'--steps-count: '+stepsCount"
			v-for="i in stepsCount"
			:class="{
				done: i < progress,
				active: i === progress,
				loading: stepLoading(i),
				failed: stepFailed(i)
			}"
		>
			<div class="step-line"></div>
			<div class="step-circle" :class="{center: isCenterStep(i)}">
				<div class="step-circle-inner">
					<div v-if="stepLoading(i)" class="circle-check ai-circle-icon" v-html="getIcon('iconAi')"></div>
					<div v-else-if="stepFailed(i)" class="circle-check warn-icon" v-html="getIcon('iconWarning')"></div>
					<div v-else-if="!isLastStep(i)" class="circle-check" v-html="getIcon('iconV')"></div>
					<div v-if="isLastStep(i)" class="flag-icon" v-html="getIcon('raceFlag')"></div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>

import {useSvgStore} from "@/shared/stores";
import {useFunnelStore} from "@/console-new/stores";
export default {
	setup() {
		let svgStore = useSvgStore();
		let funnelStore = useFunnelStore();
		return {getIcon: svgStore.get, funnelStore};
	},
	name: "FunnelStepsBottomSheetSteps",
	data() {
		return {

		}
	},
	props: {
		steps: {
			type: Array,
			default: () => [],
		},
		progress: {
			type: Number,
			default: 1
		}
	},
	computed: {
		stepsCount() {
			return this.steps?.length || 0;
		},
	},
	methods: {
		isLastStep(i) {
			return (i - 1) === this.stepsCount;
		},
		isRegistryStep(i) {
			let step = this.steps?.[i - 1];
			return step?.slotName === 'products-registry';
		},
		isCenterStep(i) {
			//stepsCount is odd and i is the middle step
			if (this.stepsCount % 2 !== 0 && (i - 1) === Math.floor(this.stepsCount / 2)) {
				return true;
			}
		},
		stepLoading(stepIndex) {
			return this.isRegistryStep(stepIndex) && this.funnelStore.pollingMenuUpload;
		},
		stepFailed(stepIndex) {
			return this.isRegistryStep(stepIndex) && this.funnelStore.errorMenuUpload;
		}
	}
}
</script>

<style lang="scss" scoped>
.bottom-sheet-steps {
	@include centered;
	justify-content: space-between;
	width: 100%;
	height: 55px;
	padding: 0 20px;
	box-shadow: $box_shadow_inset, 0 -5px 10px var(--color-box-shadow-1);

	.step {
		@include centered;
		justify-content: space-between;

		&:not(:first-of-type) {
			width: calc(calc(100% - 46px) / (var(--steps-count) - 1));
		}

		.step-circle {
			@include centered;
			width: 35px;
			height: 35px;
			border-radius: 50%;
			background-color: var(--color-alpha-2);
			border: 1px solid var(--color-alpha-2);
			position: relative;

			&.center:after {
				content: '';
				position: absolute;
				top: -1px;
				left: -1px;
				width: calc(100% + 2px);
				height: 51%;
				background-color: var(--color-bg);
				z-index: 0;
				border-bottom: 1px solid var(--color-alpha-4);
				@media (max-width: 480px) {
					display: none;
				}
			}

			.step-circle-inner {
				@include centered;
				background-color: var(--color-bg);
				width: 22px;
				height: 22px;
				border-radius: 50%;

				.circle-check {
					@include centered;
					display: none;

					&:deep(svg) {
						height: 10px;
						width: 10px;

						.stroke {
							stroke: var(--color-bg);
						}

						.fill {
							fill: var(--color-bg);
						}
					}
					&.ai-circle-icon, &.warn-icon {
						&:deep(svg) {
							height: 14px;
							width: 14px;
						}
					}
				}
				.flag-icon {
					@include centered;
					display: flex;

					&:deep(svg) {
						height: 12px;
						width: 12px;

						.stroke { stroke: var(--color-alpha-2); }
						.fill { fill: var(--color-alpha-2); }
					}
				}
			}


		}

		.step-line {
			width: calc(100% - 40px);
			height: 4px;
			border-radius: 2px;
			background-color: var(--color-alpha-2);
		}
		@media (max-width: 600px) {
			.step-circle {
				width: 24px;
				height: 24px;

				.step-circle-inner {
					width: 17px;
					height: 17px;
				}
			}
			.step-line { width: calc(100% - 30px); }
		}
		@media (max-width: 420px) {
			.step-circle {
				width: 22px;
				height: 22px;

				.step-circle-inner {
					width: 15px;
					height: 15px;
				}
			}
			.step-line { width: calc(100% - 26px); }
		}

		&.active {
			.step-circle {
				background-color: var(--color-bg);
				border: 1px solid var(--color-primary);

				.step-circle-inner {
					background-color: var(--color-primary);

					.flag-icon {
						&:deep(svg) {
							.stroke { stroke: var(--color-bg); }
							.fill { fill: var(--color-bg); }
						}
					}
				}
				&.center:after {
					border-bottom: 1px solid var(--color-primary);
				}
			}
			.step-line { background-color: var(--color-primary); }
		}
		&.done {
			.step-circle {
				background-color: var(--color-bg);
				border: 1px solid #0C9A72;

				.step-circle-inner {
					background-color: #0C9A72;

					.flag-icon {
						&:deep(svg) {
							.stroke { stroke: var(--color-bg); }
							.fill { fill: var(--color-bg); }
						}
					}
				}
				&.center:after {
					border-bottom: 1px solid #0C9A72;
				}
				&:not(.center) .circle-check {
					display: flex;
				}
			}
			.step-line { background-color: #0C9A72; }
		}
		&.loading {
			.step-circle {
				background-color: var(--color-bg);
				border: 1px solid #8F4DFE;

				.step-circle-inner {
					background-color: #8F4DFE;
				}
				&.center:after {
					border-bottom: 1px solid #8F4DFE;
				}
				&:not(.center) .circle-check {
					display: flex;
				}
			}
			.step-line { background-color: #8F4DFE; }
		}
		&.failed {
			.step-circle {
				background-color: var(--color-bg);
				border: 1px solid var(--color-danger);

				.step-circle-inner {
					background-color: var(--color-danger);
				}
				&.center:after {
					border-bottom: 1px solid var(--color-danger);
				}
				&:not(.center) .circle-check {
					display: flex;
				}
			}
			.step-line { background-color: var(--color-danger); }
		}
	}
}
</style>